import request from '@/modules/huyu-framework/backend/utils/request'

// 获取启用的代币配置列表（额度管理页面代币切换）
export function getTokenOptions() {
  return request({ url: '/huyuAI/credit/tokens', method: 'get' })
}

export function rechargeCredit(data) {
  return request({ url: '/huyuAI/credit/recharge', method: 'post', data })
}

// 获取代币配置（含代币名称、单位等）
export function getTokenConfig(tokenCode) {
  // projectRootDeptId=true：激活后端 @DataScope(allowProjectRootDept) 逃生机制，
  // 按项目根部门（如方恒 307）查代币配置，解决"配置挂项目根、用户挂子部门查不到"问题
  // silentError：这是「可选配置」读取（代币单位换算），项目没启用支付/没配代币时
  // 只降级为空单位，不允许弹全局错误提示（tokenUnit.js 已兜底返回 ''）
  return request({ url: '/pay/credit/token/' + tokenCode, method: 'get', params: { projectRootDeptId: true }, headers: { silentError: true } })
}

// 统一余额查询（按代币配置的 balance_dimension 自动路由：user=用户余额 / card=卡片余额，单位分）
// cardId：选中房间卡时按单卡查询（返回该卡自身余额），否则传空按用户聚合
export function getUnifiedBalance(userId, tokenCode, cardId) {
  return request({ url: '/pay/credit/balance', method: 'get', params: { userId, tokenCode, cardId } })
}

// 统一变动流水（分页，按代币配置的 balance_dimension 自动路由，返回结构对齐）
export function listUnifiedChangeRecord(query) {
  return request({ url: '/pay/credit/changeRecord', method: 'get', params: query })
}

// 已注册余额维度列表（user=用户余额 / card=卡片余额，新增维度实现后自动出现）
export function getBalanceDimensions() {
  return request({ url: '/pay/credit/dimensions', method: 'get' })
}

// 统一搜索余额主体（按代币配置的 balance_dimension 自动路由：user 维度搜用户 / card 维度搜卡片）
export function searchBalanceTarget(keyword, tokenCode, limit) {
  return request({ url: '/pay/credit/search', method: 'get', params: { keyword, tokenCode, limit } })
}

// 更新代币配置
export function updateTokenConfig(data) {
  return request({ url: '/pay/credit/token', method: 'put', data })
}

// ==================== AI 每日签到（积分即 AI 额度） ====================
// 签到发放逻辑在 pay 侧（pay_token_signin_record 按 用户+代币+部门+日期 幂等），
// 后台、官网浮窗、其它 AI 页面共用同一份记录：任一处签到过，其余处当天都显示「已签到」。

// 当前登录用户的 AI 积分账户（不存在时后端返回空账户口径，前端按 0 处理）
export function getCreditAccount(tokenCode = 'ai_token') {
  return request({ url: '/pay/credit/account', method: 'get', params: { tokenCode }, headers: { silentError: true } })
}

// 今日签到状态：signedToday / signinEnabled / signinAmount
export function getSigninStatus(tokenCode = 'ai_token') {
  return request({ url: '/pay/credit/signin/status', method: 'get', params: { tokenCode }, headers: { silentError: true } })
}

// 执行签到（重复签到由后端拒绝并返回「今日已签到」）
export function signinCredit(tokenCode = 'ai_token') {
  return request({ url: '/pay/credit/signin', method: 'post', params: { tokenCode } })
}

// ==================== 统一财务统计（与交易明细 /pay/credit/changeRecord 同源同口径） ====================
// 财务汇总统计
export function getUnifiedCreditStatisticsSummary(query) {
  return request({ url: '/pay/credit/statistics/summary', method: 'get', params: query })
}

// 财务按日趋势统计
export function getUnifiedCreditStatisticsTrend(query) {
  return request({ url: '/pay/credit/statistics/trend', method: 'get', params: query })
}

// 财务按变动类型统计
export function getUnifiedCreditStatisticsType(query) {
  return request({ url: '/pay/credit/statistics/type', method: 'get', params: query })
}

// 财务统计余额明细（点击汇总卡片下钻，与统计同源同口径）
export function getUnifiedCreditStatisticsDetail(query) {
  return request({ url: '/pay/credit/statistics/detail', method: 'get', params: query })
}
